import { Construction, ArrowLeft, Sparkles } from 'lucide-react';
import { useLocation, Link } from 'react-router-dom';
import { findModuleByPath } from '../data/navigation';

/**
 * ModulePlaceholder — generic "coming soon" landing used by every module
 * route until the real feature pages land (see docs/MODULES_MAP.md).
 * Renders a centered "Segera Hadir" state inside the shell content area.
 */
export default function ModulePlaceholder() {
  const { pathname } = useLocation();
  const module = findModuleByPath(pathname);
  const Icon = module?.icon ?? Construction;

  return (
    <div className="module-placeholder">
      <div className="module-placeholder__body">
        <div className="module-placeholder__icon">
          <Icon size={40} strokeWidth={1.75} />
        </div>
        <h2 className="module-placeholder__title">{module?.label ?? 'Modul'}</h2>
        <span className="module-placeholder__badge">
          <Sparkles size={14} />
          Segera Hadir
        </span>
        <p className="module-placeholder__desc">
          {module?.description ?? 'Modul ini sedang dikembangkan.'} — fitur ini
          sedang disiapkan dan akan tersedia pada pembaruan berikutnya.
        </p>
        <Link className="module-placeholder__back" to="/dashboard">
          <ArrowLeft size={16} />
          <span>Kembali ke Dashboard</span>
        </Link>
      </div>
    </div>
  );
}
